import { Port } from '@api/utils/ports';
import { PortActionTypes } from './constants';
import { splitActionKey } from './splitActionKey';

export const sortCargoPorts = <CargoPort extends {
	port: Port;
	portAndActionKey: string;
	portCallId: number | null;
}>(
	cargoPorts: Array<CargoPort>,
	portCalls?: Array<{ id: number; port: Port }>,
): Array<CargoPort> => cargoPorts
	.sort((a, b) => {
		// First, sort by port call order if portCalls are provided
		if (portCalls) {
			const indexA = portCalls.findIndex((pc) => {
				if (a.portCallId) {
					return pc.id === a.portCallId;
				}

				return a?.port?.id === pc?.port?.id;
			});

			const indexB = portCalls.findIndex((pc) => {
				if (b?.portCallId) {
					return pc.id === b.portCallId;
				}

				return b?.port?.id === pc?.port?.id;
			});

			if (indexA !== indexB && indexA !== -1 && indexB !== -1) {
				return indexA - indexB;
			}
		}

		const { action: actionA } = splitActionKey(a.portAndActionKey);
		const { action: actionB } = splitActionKey(b.portAndActionKey);

		// Within the same port call order, loading comes before discharging
		if (actionA === PortActionTypes.LOADING && actionB === PortActionTypes.DISCHARGING) {
			return -1;
		}

		if (actionA === PortActionTypes.DISCHARGING && actionB === PortActionTypes.LOADING) {
			return 1;
		}

		const portA = a.port.name;
		const portB = b.port.name;

		return portA.localeCompare(portB);
	});
